var SlideNav = {
    $el: $('[data-trigger="slide-nav"]'),

    init: function() {
        SlideNav.__initEventHandlers();
    },

    __initEventHandlers: function() {
        SlideNav.$el.find('.c-nav__item.has-children').children('a').on('click', function(event) {
            event.preventDefault();

            if ($(this).next('ul').hasClass('is-hidden')) {
                $(this).next('ul').removeClass('is-hidden').end().parent('.c-nav__item.has-children').parent('ul').addClass('t-moves-out');
                $(this).parent('.c-nav__item.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a');
            } else {
                $(this).next('ul').addClass('is-hidden').end().parent('.c-nav__item.has-children').parent('ul').removeClass('t-moves-out');
            }
        });

        SlideNav.$el.find('.c-nav__go-back').on('click', function() {
            $(this).parent('ul').addClass('is-hidden').parent('.c-nav__item.has-children').parent('ul').removeClass('t-moves-out');
        });

        $(document).on('beforeSlideoutsOpen', function() {
            SlideNav.$el.addClass('is-visible');
        });

        $(document).on('beforeSlideoutsClose', function() {
            SlideNav.$el.removeClass('is-visible');
        });
    },
}

export default SlideNav;



// WEBPACK FOOTER //
// ./scripts/components/slide-nav.js